import { useState } from 'react'
import { CaretDownOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { auxaliaColors } from '@shared/theme'
import { APP_VERSION } from '@shared/config/version'
import { AboutAXFlowAdminPopover } from './AboutAXFlowAdminPopover'

interface Props {
  collapsed: boolean
}

export function AdminSidebarFooter({ collapsed }: Props) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  return (
    <div
      style={{
        borderTop: '1px solid rgba(255,255,255,0.12)',
        padding: 10,
        overflow: 'hidden',
        flexShrink: 0,
      }}
    >
      <AboutAXFlowAdminPopover open={open} onOpenChange={setOpen}>
        <button
          type="button"
          aria-label={t('sidebar.about.ariaLabel')}
          aria-haspopup="true"
          aria-expanded={open}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            padding: 10,
            borderRadius: 8,
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            width: '100%',
            textAlign: 'left',
          }}
        >
          <span
            aria-hidden="true"
            style={{
              width: 32, height: 32, borderRadius: 7,
              background: `linear-gradient(135deg, ${auxaliaColors.lime}, ${auxaliaColors.limeDark})`,
              color: auxaliaColors.navy, fontWeight: 700, fontSize: 13,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            AX
          </span>
          {!collapsed && (
            <>
              <span style={{ flex: 1, minWidth: 0 }}>
                <span style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#fff', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  AX<span style={{ color: auxaliaColors.lime }}>Flow</span>
                </span>
                <span style={{ display: 'block', fontSize: 10.5, color: 'rgba(255,255,255,0.55)', fontFamily: 'JetBrains Mono, monospace', letterSpacing: '0.04em' }}>
                  v{APP_VERSION} · {t('sidebar.about.admin')}
                </span>
              </span>
              <CaretDownOutlined style={{ color: 'rgba(255,255,255,0.38)', fontSize: 11, flexShrink: 0 }} />
            </>
          )}
        </button>
      </AboutAXFlowAdminPopover>
    </div>
  )
}
